<template>
    <auth-layout>
        <header-page title="Published"/>
        <loading-block v-if="loading" />
        <div v-else>
            <no-video v-if="total === 0 && search === ''"/>
            <div v-else>
                <div class="page-post-title">
                    <div>
                        Total Publish: <b>{{ total }}</b>
                    </div>
                    <div>
                        <search-article @search="searchArticle" :query="search"/>
                    </div>
                </div>
                <hr/>
                <div class="page-post">
                    <video-card v-for="item in articles"
                        :key="item._id"
                        type="published"
                        :title="item.judul"
                        :date="item.create_date"
                        :image="item.file.length > 0 ? item.file[0].fullpath : null"
                        :published_data="item.published_data"
                        :status="item.status"
                    />
                </div>
                <div class="page-post-page-info text-center">
                    {{current_page}}-{{last_page}} dari <b>{{ total }}</b>
                </div>
                <div class="button-wrap">
                    <div class="row">
                        <div class="col-6">
                            <button class="btn btn-primary main-button pill-button" @click="prevPage" :disabled="current_page === 1">Sebelumnya</button>
                        </div>
                        <div class="col-6">
                            <button class="btn btn-primary main-button pill-button bg-orange" @click="nextPage" :disabled="!next_page_url">Selanjutnya</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </auth-layout>
</template>
<script>
import axios from "axios";

export default {
    data() {
        return {
            loading: true,
            articles: [],
            current_page: 1,
            per_page: '',
            last_page: '',
            to: '',
            total: '',
            next_page_url: '',
            search: ''
        }
    },
    mounted() {
        this.getData()
    },
    methods: {
        getData (page = 1) {
            const token = this.$cookies.get('token');
            axios.get(`/api/video?page=${page}&search=${this.search}`, { headers: {"Authorization" : `Bearer ${token}`} })
                .then((response) => {
                    this.articles = response.data.data
                    this.current_page = response.data.current_page
                    this.per_page = response.data.per_page
                    this.last_page = response.data.last_page
                    this.to = response.data.to
                    this.total = response.data.total
                    this.next_page_url = response.data.next_page_url
                    this.loading = false
                })
                .catch((error) => {

                });
        },
        nextPage() {
            const page = this.current_page + 1;
            this.getData(page)
            window.scrollTo(0,0);
        },
        prevPage() {
            const page = this.current_page - 1;
            this.getData(page)
            window.scrollTo(0,0);
        },
        searchArticle(query) {
            this.search = query;
            this.getData();
        }
    }
}
</script>
<style scoped>
.page-post {
    padding: 0 5%;
}
.page-post-title {
    padding: 0 5%;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
</style>
